export default __webpack_public_path__ + "static/node@2x-6e2ccef7ae2fe6e9a2d5f78829706f55.png";